module.exports = __webpack_public_path__ + "img/subBanner6.75e928b4.png";